import { render, staticRenderFns } from "./PageTemplateStockists.vue?vue&type=template&id=d4aca844&"
import script from "./PageTemplateStockists.vue?vue&type=script&lang=js&"
export * from "./PageTemplateStockists.vue?vue&type=script&lang=js&"
import style0 from "./PageTemplateStockists.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports